import React, { Component } from 'react'
import axios from './axios'
import Translate from '../components/translate/conf'
import 'datatables.net-buttons-bs4/js/buttons.bootstrap4.min.js'
import 'datatables.net-responsive-bs4/js/responsive.bootstrap4.min.js'
import ModalLoading from '@app/components/modal-loading/modal-loading';
import ReactDOMServer from 'react-dom/server';

const $ = require('jquery');
$.DataTable = require('datatables.net');

export default class OltPonInfoTable extends Component {

  constructor(props) {
    super(props)
    this.state = {
      rows: [],
      mLoading: true
    }
  }

  getFullOltData = async () => {
    let oltTable = await axios.get('/api/olttable')
    let moduleOltTable = await axios.get('/api/moduleolttable')
    if( oltTable.data.data !== undefined && moduleOltTable.data.data !== undefined ){
      oltTable = oltTable.data.data;
      moduleOltTable.data.data.forEach((v,i,arr)=> {
        for(let j=0;j<oltTable.length;j++){
          if( v.ucOpticModuleOltSlotIndex == oltTable[j].ucCfgOLTSlotIndex ){
            arr[i] = { ...v, ...oltTable[j] }
            break;
          }
        }
      })
      return moduleOltTable;
    }
    return { data: [] };
  }

  getTableData = async () => {
    try {
      const res = await this.getFullOltData();
      this.setState(
        {
          rows: res.data["data"],
          mLoading: false
        },
        () => {
          $(this.tbl).DataTable({
            "pageLength": 16,
            "lengthMenu": [0, 2, 4, 8, 16],
            "responsive": true,
            "columnDefs": [
              {
                visible: false,
                targets: 0,
              },
              {
                width: '50%',
                targets: 1,
                className: 'th-bg-blue td-blue td-tiny'
              },
              {
                targets: [2, 3, 4, 5, 6, 7],
                className: 'dt-center th-bg-blue td-blue td-tiny'
              }
            ],
            initComplete: function () {
              this.api()
                  .columns()
                  .every(function () {
                      var that = this;
                      $('input', this.footer()).on('keyup change clear', function () {
                          if (that.search() !== this.value) {
                              that.search(this.value).draw();
                          }
                      });
                  });
            },
          });
        }
      )
    } catch (e) { 
      console.log(e)
    }
  }

  componentDidMount() {
    this.getTableData();
  }

  tHeader = () => {
    return (
      <>
        <thead>
          <tr>
            <th></th>
            <th><Translate transVar='OLT.Name' /></th>
            <th><Translate transVar='OLT.Slot' /></th>
            <th><Translate transVar='OLT.PONInfo.PON' /></th>
            <th><Translate transVar='OLT.PONInfo.Temperature' /><p style={{margin:0}}>ºC</p></th>
            <th><Translate transVar='OLT.PONInfo.TXBias' /><p style={{margin:0}}>mA</p></th>
            <th><Translate transVar='OLT.PONInfo.TXPower' /><p style={{margin:0}}>dBm</p></th>
            <th><Translate transVar='OLT.PONInfo.VCC' /></th>
          </tr>
        </thead>
      </>
    );
  }

  tFooter = () => {
    return (
      <>
        <tfoot>
          <tr>
            <td></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.Name' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.Slot' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.PONInfo.PON' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.PONInfo.Temperature' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.PONInfo.TXBias' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.PONInfo.TXPower' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.PONInfo.VCC' />)} /></td>
          </tr>
        </tfoot>
      </>
    );
  }
  
  tBody = () => {
    let arrTd = []
    this.state.rows.forEach((e, i) => {
      arrTd.push(
        <tr key={i}>
          <td>{e.id}</td>
          <td>{e.ucCfgOLTName}</td>
          <td>{e.ucOpticModuleOltSlotIndex}</td>
          <td>{e.ucOpticModuleOltPonIndex}</td>
          <td>{e.ucOpticModuleOltTemperature}</td>
          <td>{e.ucOpticModuleOltTxBias}</td>
          <td>{e.ucOpticModuleOltTxPower}</td>
          <td>{e.ucOpticModuleOltVcc}</td>
        </tr>
      )
    });
    return (
      <>
        <tbody>{arrTd}</tbody>
      </>
    )
  }

  render() {
    return (
      <>
        <ModalLoading show={this.state.mLoading} />
        {!this.state.mLoading &&
          <table width="100%" ref={(tbl) => (this.tbl = tbl)} className='table table-striped'>
            <this.tHeader />
            <this.tBody />
            <this.tFooter />
          </table>
        }
      </>
    )
  }
}
